import { Stack, Typography, Table, TableBody, TableRow, TableCell } from "@mui/material"
import { useTranslate } from "react-admin"
import AddCommentForInvoice from "./actionDialogs/AddCommentForInvoice"
import RemoveCommentForInvoice from "./actionDialogs/RemoveCommentForInvoice"

interface IProps {
  resource: "invoices" | "drafts" | "reverseInvoices" | "invoiceReminders"
  comments?: string[] | null
}

const Comments = ({resource, comments}: IProps) => {
  const translate = useTranslate()
  return (
    <Stack width={"100%"} spacing={2} >
      <Typography variant="h6">
        {translate("resources.invoices.comment", {smart_count: comments ? comments?.length : 0})}:
      </Typography>
      {
        comments && comments.length > 0 ?
        <Table size="small">
          <TableBody>
            {
              comments.map((comment, index) => 
                <TableRow>
                  <TableCell>
                    <Typography variant="body2" fontStyle={"italic"} whiteSpace={"pre-wrap"}>"{comment}"</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <RemoveCommentForInvoice index={index} resource={resource} />
                  </TableCell>
                </TableRow>
              )
            }
          </TableBody>
        </Table> :
        <Typography variant="body2" fontStyle={"italic"} whiteSpace={"pre-wrap"}>Keine Kommentare</Typography>
      }
      <AddCommentForInvoice resource={resource} />
    </Stack>
  )
}

export default Comments